import Modal from "@/components/Modal";
import Spacer from "@/components/Spacer";
import { useCallback, useEffect, useState } from "react";
import useNoodleApi from "@/hooks/useNoodleApi";
import { getExtractedData } from "@/tsClient/documentRequests";
import Shimmer from "@/components/Shimmer";
import s from './DocumentPreview.module.scss';
import PrettyJson from "./PrettyJson";

type Props = {
  onClose: () => void;
  documentId: string;
};

const DEFAULT_IMAGE_JSON_DATA = {
  document: 'no extracted data was found',
};

const ExtractedDataModal: React.FC<Props> = ({ onClose, documentId }) => {
  const [extractedData, setExtractedData] = useState<unknown>(DEFAULT_IMAGE_JSON_DATA);
  const { getData: getExtractedDataFn, fetchingState:{isFetching} } = useNoodleApi(getExtractedData);

  const fetchExtractedData = useCallback(async (): Promise<void> => {
    const res = await getExtractedDataFn({
      documentId,
    });
    if (res.data) {
      setExtractedData(res.data);
    }
  }, [documentId, getExtractedDataFn]);

  useEffect(() => {
    if (documentId) {
      fetchExtractedData();
    }
  }, [documentId, fetchExtractedData]);

  return (
    <Modal
      hideBottomInset
      title="Data extracted by AI"
      onClose={onClose}

    >

      {isFetching
        ?<div className={s['loader-container']}>
          <Shimmer className={s.shimmer}/>
          <Spacer/>
          <Shimmer className={s.shimmer}/>
        </div>
        : <><div
          style={{
            padding: 24,
          }}
        >
          <label className={s.prompt}>
              Data
          </label >
          <PrettyJson
            stringifiedJson={JSON.stringify(extractedData)}
          />
        </div></>}
    </Modal>
  );
};

export default ExtractedDataModal;
